import React, { Component }from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import StyleLink from '../dev/StyleLink'
import YtIconWhite from '../icon/YtIconWhite'
import Engage from '../icon/Engage';
import Eye from '../icon/Eye';
// 圖名模糊 影片defalut不是台灣 互動都0
class VideoList extends Component {
    //convertDate = date => date.replace('.000Z', '').replace('T', '\u0009'); 影片搜尋 API 改成從自己資料庫搜尋，因此時間格式不會有Z跟T，PM 改一下
    comma = value => {
        if (isNaN(value)) {
            return value;
        }
        else {
            return Number(value).toLocaleString()
        }
    }
    render() {
        const { videoList, messages, infoList: { videoSortCategory }, isInfoListTourActive  } = this.props
        return (
            <div>{videoList.map((channel, index) => {
                const { thumbnail, title, description, videoId, channelId, channelTitle, channelPk, subscriberCount, viewCount, engageRate, publishedAt
                } = channel
                const { /*convertDate,*/comma } = this
                return (
                    <ChannelWrap>
                        <StyleLink to={`https://www.youtube.com/watch?v=${videoId}`} target='_blank'>
                            <Thumbnail thumbnail={thumbnail}>
                                <YtIconWhite />
                            </Thumbnail>
                        </StyleLink>
                        <VideoInfoWrap>
                            <div>
                                <StyleLink to={`https://www.youtube.com/channel/${channelId}`} target='_blank'>
                                    <Title>{title}</Title>
                                </StyleLink>
                                <Subtitle>
                                    <StyleLink to={`https://www.youtube.com/channel/${channelId}`} target='_blank'>
                                        {channelTitle}
                                        {` | ${messages.channel_subscriber}`} <SubscriberCount highlight={videoSortCategory === 'subscriberCount'}>{comma(subscriberCount)}</SubscriberCount>
                                        {` | ${publishedAt}`}
                                    </StyleLink>
                                </Subtitle> 
                                <Description>{description}</Description>                               
                            </div>
                            <Footer>
                                <div>
                                    <Eye size={15} />
                                    <FooterContent highlight={videoSortCategory === 'viewCount'}>{comma(viewCount)}</FooterContent>
                                    <Engage size={12} />
                                    <FooterContent highlight={videoSortCategory === 'engageRate'}>{engageRate}%</FooterContent>
                                </div>
                                <StyleLink to={`/Info/${channelPk}`} target='_blank'>
                                    <ChannelDetail id={isInfoListTourActive && index === 0 && "user_tour_infolist_7"}>{messages.info_list_video_channel}</ChannelDetail>
                                </StyleLink>
                            </Footer>
                        </VideoInfoWrap>
                    </ChannelWrap>
                )
            })}</div>
        )
    }

}
const mapStateToProps = state => {
    return {
        messages: state.Messages,
        infoList: state.InfoList,
    }
}
export default connect(mapStateToProps)(VideoList);

const backgroundWidth = 900
const ChannelWrap = styled.div`
    position: relative;
    display: flex;
    width: ${backgroundWidth}px;
    height: 225px;
    padding: 20px 0 20px 20px;
    margin-bottom: 10px;
    background-color: #fff;
`
const Thumbnail = styled.div`
    position: relative;
    width: ${backgroundWidth/3}px;
    height: 100%;
    background: url('${props => props.thumbnail}');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
    &:before {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        background: #787878;
        opacity: .75;
        transition: all .5s;
    }
    svg {
        transition: all .5s;
    }
    &:hover {
        &:before {
            opacity: 0;
        }
        svg {
            opacity: 0;
        }
    }
`
const VideoInfoWrap = styled.div`
    display: flex;
    width: ${backgroundWidth*2/3}px;
    justify-content: space-between;
    flex-direction: column;
    padding: 0 40px 0 20px;
`
const Title = styled.div`
    display: inline-flex;
    font-weight: 500;
    font-size: 1rem;
    color: #666666; //這邊垃圾 PM 加了一下斷行，Chrome 看會截斷多'...' 其他會直接截斷
    overflow: hidden; 
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
`
const Subtitle = styled.div`
    display: flex;
    font-size: .6rem;
    color: #787878;
    margin-top: 10px;
    max-height: 50px;
    a {
        color: #787878;
        :hover {
            color: #666666;
        }
    }
`
const SubscriberCount = styled.span`
    ${({ highlight }) => highlight ? 'color: #de0606; font-weight: 500' : ''};
`
const Description = Subtitle.extend`
    overflow-y: scroll;
`
const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    svg {
        margin-right: 10px;
    }
    div {
        display: flex;
        align-items: center;
    }
`
const FooterContent = styled.div`
    margin-right: 20px;
    font-size: .8rem;
    font-weight: 500;
    ${({ highlight }) => highlight ? 'color: #de0606; font-weight: 500' : ''};
`
const ChannelDetail = styled.div`
    font-size: .7rem;
    color: #de0606;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/InfoList/VideoList.js